class cToolsMarc {
    constructor() {
        var self = this;
        $(function () { self.onload(); });
    }
    onload() {
        var self = this;
        var elDelBtns = $('.marc-edit-field-delete');
        elDelBtns.click(function (e) { return self.onDelBtnClick(this, e); });
    }
    onDelBtnClick(btn, e) {
        if (confirm('Are you sure you want to delete this field?')) {
            $(btn).closest('div.marc-edit-rows').fadeOut('slow').remove();
            $('#marc-edit-form').submit();
            return;
        }
    }
}
